/**
 * region for libraries*/
import React, { Component } from 'react';

/**
 * region for helpers*/
import typing from '../../../../helpers/typing';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'

export class Header extends Component {
    static displayName = Header.name;

    constructor(props) {
        super(props);

        this.state = {
            searchFilter: { }
        };
    }

    handleChangeSearch() {
        if (this.props.onSearchChanged) {
            this.props.onSearchChanged(this.state.searchFilter);
        }
    }

    onKeyPress = (e) => {
        if (e.which === 13) {
            this.handleChangeSearch();
        }
    }

    handleInputChange(fieldName, value, hasToRefresh) {
        this.setState({ searchFilter: typing.extend(this.state.searchFilter, { [fieldName]: value }) });

        this.props.onChangeDropdown(this.state.searchFilter);
        
        if (hasToRefresh) {
            this.handleChangeSearch();
        }
    }

    render() {
        const self = this;
        return (

            <div className="table-responsive">
                <table className="table table-product-search">
                    <thead className="table-title-row-collapse">
                        <tr>
                            <th colSpan="15" className="text-center font-size-lg">
                                Product search
                                {this.props.parentMode === Constants.MODE_LOADED
                                    && this.props.totalRows >= 0
                                    && <span> ({this.props.totalRows} results)</span>
                                }
                                {this.props.parentMode === Constants.MODE_LOADING
                                    && <span>...</span>}

                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="d-flex-align-items-center">
                            <td>
                                <input type="number"
                                    placeholder="Client Id"
                                    value={this.state.searchFilter.IDCLIENT || ''}
                                    className="form-control form-control-md"
                                    onChange={e => self.handleInputChange('IDCLIENT', e.target.value)}
                                    onKeyPress={this.onKeyPress}
                                />
                            </td>
                            <td>
                                <input type="number"
                                    placeholder="Product Id"
                                    value={this.state.searchFilter.IDCONTENT || ''}
                                    className="form-control form-control-md"
                                    onChange={e => self.handleInputChange('IDCONTENT', e.target.value)}
                                    onKeyPress={this.onKeyPress}
                                />
                            </td>
                            <td>
                                <input type="text"
                                    placeholder="Product Name"
                                    value={this.state.searchFilter.PRODUCTTITLE || ''}
                                    className="form-control form-control-md"
                                    onChange={e => self.handleInputChange('PRODUCTTITLE', e.target.value)}
                                    onKeyPress={this.onKeyPress}
                                />
                            </td>
                            <td>
                                <input type="text"
                                    placeholder="Brand name"
                                    value={this.state.searchFilter.BRAND_NAME || ''}
                                    className="form-control form-control-md"
                                    onChange={e => self.handleInputChange('BRAND_NAME', e.target.value)}
                                    onKeyPress={this.onKeyPress}
                                />
                            </td>
                            <td>
                                <input type="text"
                                    placeholder="Model No."
                                    value={this.state.searchFilter.MODEL_NO || ''}
                                    className="form-control form-control-md"
                                    onChange={e => self.handleInputChange('MODEL_NO', e.target.value)}
                                    onKeyPress={this.onKeyPress}
                                />
                            </td>
                            <td>
                                <input type="text"
                                    placeholder="Description"
                                    value={this.state.searchFilter.DESCRIPTION || ''}
                                    className="form-control form-control-md"
                                    onChange={e => self.handleInputChange('DESCRIPTION', e.target.value)}
                                    onKeyPress={this.onKeyPress}
                                />
                            </td>
                            <td>  
                                <div className="btn-group btn-group-md">
                                    <select className="custom-select custom-select-md form-control-md" 
                                        value={this.state.searchFilter.KEYWORDS_IN_TITLE || ''}
                                        onChange={e => self.handleInputChange('KEYWORDS_IN_TITLE', e.target.value, true)}>
                                        <option value={''}>Keywords in title (Show all)</option>
                                        <option value={true}>With keywords in title</option>
                                        <option value={false}>Without keywords in title</option>
                                    </select>
                                </div>                                
                            </td>
                            <td>
                                <div className="btn-group btn-group-md">
                                    <select className="custom-select custom-select-md form-control-md"
                                        value={this.state.searchFilter.ISCLIENT || ''}
                                        onChange={e => self.handleInputChange('ISCLIENT', e.target.value , true)} >
                                        <option value={''}>Any profile status</option>
                                        <option value={true}>Clients</option>
                                        <option value={false}>Free</option>
                                    </select>
                                </div>
                            </td>
                            <td>
                                <div className="btn-group btn-group-md">
                                    <select className="custom-select custom-select-md form-control-md"
                                        value={this.state.searchFilter.ONLINE || ''}
                                        onChange={e => self.handleInputChange('ONLINE', e.target.value , true)} >                                        
                                        <option value={''}>Any published status</option>
                                        <option value={true}>Online</option>
                                        <option value={false}>Offline</option>
                                    </select>
                                </div>
                            </td>
                            
                        </tr>
                        <tr className="d-flex-align-items-center">
                        <td><button className="btn btn-info" onClick={self.handleChangeSearch.bind(this)}>Search</button></td>
                        </tr>
                        {this.props.parentMode === Constants.MODE_LOADED
                            && this.props.totalRows > 2000
                            &&
                            <div className="sg-pattern-example">
                                <div className="alert alert-warning">
                                    <strong>Warning!</strong> The result is bigger than 2000 products. Please filter it.
                                </div>
                            </div>
                        }
                    </tbody>
                </table>
            </div>

        );
    }
}
